import { SUPPORT_ADDRESS } from '../lib/signInErrors'

/**
 * Renders a sentence that names SUPPORT_ADDRESS with the address as a mailto
 * link carrying the prefilled subject and body (lib/supportMail.ts). The
 * sentence itself stays one string in signInErrors/signInCopy, so the words
 * are reviewed in one place and the link is decoration on top of them.
 *
 * A sentence without the address renders unchanged — which is how the
 * sign-in error line can pass every error through here: only the not-found
 * refusal names support.
 *
 * In components/, not routes/, so the suite can render it (Traps: a route
 * pulls in an SVG the test bundler cannot resolve).
 */
export function SupportText({ text, href }: { text: string; href: string }) {
  const at = text.indexOf(SUPPORT_ADDRESS)
  if (at < 0) return <>{text}</>
  return (
    <>
      {text.slice(0, at)}
      <a href={href}>{SUPPORT_ADDRESS}</a>
      {text.slice(at + SUPPORT_ADDRESS.length)}
    </>
  )
}
